export default "__VITE_ASSET__DouMalC9__"